import { Add } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import SearchProvider from 'components/search/search.context';
import { useHasPermission } from 'hooks/authorization.hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import MenusDataGrid from '../menus-data-grid/menus-data-grid.component';
import { useMenusSearch } from '../menus-landing.hooks';
import BulkEditDataGridProvider from 'components/inc-data-grid/bulk-edit-data-grid/bulk-edit-data-grid.context';

const MenusNative = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const hasCreateMenuPermission = useHasPermission('CREATE_MENU');
  const search = useMenusSearch(true);

  return (
    <Box mt={2}>
      <SearchProvider value={search}>
        <SearchToolbar
          buttons={
            <>
              {hasCreateMenuPermission && (
                <Button
                  onClick={() => navigate('../create')}
                  startIcon={<Add />}
                  data-testid="Menus.Button.CreateMenu"
                  sx={{ whiteSpace: 'nowrap' }}
                  variant="text"
                >
                  {t('MenusDataGrid.buttons.createMenu')}
                </Button>
              )}
            </>
          }
        />
        <BulkEditDataGridProvider>
          <MenusDataGrid isNative={true} />
        </BulkEditDataGridProvider>
      </SearchProvider>
    </Box>
  );
};

export default MenusNative;
